module.exports = __webpack_public_path__ + "img/header-weddingRingsFacetes@2x.49c9ed5.jpg";